import { useEffect } from 'react'

/**
 * SilentCallbackPage - For iframe-based silent auth
 *
 * This minimal page handles OAuth callbacks in an iframe context.
 * It extracts the authorization response and posts it to the parent window.
 *
 * Flow:
 * 1. Parent opens this page in hidden iframe with authorization params
 * 2. Backend redirects here with code or error
 * 3. This page posts the result to parent via postMessage
 * 4. Parent receives message and completes auth flow
 */
export function SilentCallbackPage() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const code = params.get('code')
    const error = params.get('error')
    const errorDescription = params.get('error_description')
    const state = params.get('state')

    // Build response message
    const response = {
      type: 'authorization_response',
      code,
      error,
      error_description: errorDescription,
      state,
    }

    // Post to parent window
    // Note: Origin should be validated by parent, we use '*' here
    // because the parent origin may vary based on which app is using this
    if (window.parent !== window) {
      window.parent.postMessage(response, '*')
    }

    // Also try opener for popup flows
    if (window.opener) {
      window.opener.postMessage(response, '*')
      window.close()
    }
  }, [])

  // No visible UI - this is a utility page
  return null
}
